import React, { useCallback, useEffect, useState } from 'react';
import Header from '../components/header';
import SearchIcon from '@mui/icons-material/Search';
import CustomTable from '../components/customTable';
import getEnvironement from '../../environnement';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import StatutDialog from './components/statutDialog';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from '../../store/userSlice';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import DeleteDialog from './components/deleteDialog';
import MessageDialog from './components/messageDialog';
import CustomBackdrop from '../../components/backdrop';
import { setLang } from '../../store/langSlice';

export default function Messages() {
  const [searchByName, setSearchByName] = useState('');
  const [messages, setMessages] = useState([]);
  const [filtredMessages, setFiltredMessages] = useState(messages);
  const [selectedMessage, setSelectedMessage] = useState();
  const [openStatutDialog, setOpenStatutDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openMessageDialog, setOpenMessageDialog] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [badgeNotification, setBadgeNotification] = useState(0);
  const [reservationsNotification, setReservationsNotification] = useState([]);
  const [messagesNotification, setMessagesNotification] = useState([]);

  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getMessages = useCallback(async () => {
    setIsLoader(true);
    const url = `${getEnvironement().API_URL}/messages`;
    await axios.get(url)
      .then((res) => setMessages(res.data.messages))
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }, []);

  async function updateAllStatus() {
    const url = `${getEnvironement().API_URL}/updateAllMessageStatus`;
    setOpenBackdrop(true);
    await axios.post(url)
      .then(() => setTimeout(() => setOpenBackdrop(false), 800))
      .then(() => getMessages())
      .then(() => getNotificationData())
      .then(() => setTimeout(() => toast.success('statut modifié'), 800))
      .catch(() => setOpenBackdrop(false));
  }

  function getStatut(statut) {
    if (statut === 'Non traité') {
      return (<span className='bg-primary text-white px-5 rounded-full inline-block whitespace-nowrap'>Non traité</span>);
    } else {
      return 'Traité';
    }
  }

  async function getNotificationData() {
    const url = `${getEnvironement().API_URL}/notificationData`;
    await axios.post(url)
      .then((res) => {
        setReservationsNotification(res.data.reservations);
        setMessagesNotification(res.data.messages);
      })
      .then(() => setBadgeNotification(reservationsNotification.length + messagesNotification.length))
      .catch(() => {});
  }

  useEffect(() => {
    dispatch(setLang('fr'));
  }, [dispatch]);

  useEffect(() => {
    setBadgeNotification(reservationsNotification.length + messagesNotification.length);
  }, [reservationsNotification, messagesNotification]);

  useEffect(() => {
    getNotificationData();
  }, [messages]);

  useEffect(() => {
    getNotificationData();
  }, []);

  useEffect(() => {
    setFiltredMessages(messages);
    setSearchByName('');
  }, [messages]);

  useEffect(() => {
    getMessages();
  }, [getMessages]);

  useEffect(() => {
    if (user === null) {
      navigate('/admin');
    }
  }, [navigate, user]);

  return (
    <div className='h-screen flex flex-col'>
      <ToastContainer />
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <StatutDialog
        open={openStatutDialog}
        handleClose={() => setOpenStatutDialog(false)}
        reloadData={getMessages}
        message={selectedMessage}
        getNotificationData={getNotificationData}
      />
      <DeleteDialog
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        reloadData={getMessages}
        message={selectedMessage}
        getNotificationData={getNotificationData}
      />
      <MessageDialog
        open={openMessageDialog}
        handleClose={() => setOpenMessageDialog(false)}
        message={selectedMessage}
      />
      <div className='h-38'>
        <Header
          activeItem='Messages'
          reservations={reservationsNotification}
          messages={messagesNotification}
          badgeNotification={badgeNotification}
        />
      </div>
      <div className='w-full 3xl:flex 3xl:justify-center flex-grow'>
      <div className='3xl:w-[1200px] px-10 py-5 3xl:py-5 3xl:px-0 h-full flex flex-col justify-center'>
          <p className='font-bold text-2xl mb-5'>liste des messages :</p>
          <div className='sm:grid grid-cols-4 items-center gap-5'>
            <div className='border-2 border-primary rounded-[20px] flex mb-5 items-center col-start-1 col-end-3 xl:col-end-4'>
              <SearchIcon sx={{color: '#A31732', marginLeft: '20px'}} fontSize='large'/>
              <input
                placeholder='Chercher par nom'
                className='w-full font-inter font-medium text-2xl my-2 mx-5 focus:outline-none'
                onChange={(e) => {
                  setFiltredMessages(messages.filter(message => message.nom.includes(e.target.value)));
                }}
              />
            </div>
            <div
              className='group rounded-[20px] py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark col-start-3 xl:col-start-4 col-end-5'
              onClick={updateAllStatus}
            >
              <p className='font-medium px-2 text-xl w-full text-center text-white'>Marquer tous comme traités</p>
            </div>
          </div>
          <div className=''>
            <CustomTable
              headers={[
                'ID',
                'Nom et prénom',
                'N.Tél',
                'Objet',
                'Message',
                'Date',
                'Statut',
                'Actions'
              ]}
            >
              <tbody>
                {
                  filtredMessages.map((item, index) => {
                    return (
                      <tr key={index} className='border-b-2 border-gray'>
                        <td className='text-center font-medium text-xl py-2'>{item.id}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.nom}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.tel}</td>
                        <td className='text-center font-medium text-xl py-2'>{item.objet}</td>
                        <td className='text-center font-medium text-xl py-2'>
                          <Tooltip title="Afficher le contenu du message">
                            <IconButton onClick={() => {
                              setSelectedMessage(item);
                              setOpenMessageDialog(true);
                            }}
                            >
                              <VisibilityIcon sx={{color: 'black'}}/>
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td className='text-center font-medium text-xl py-2 whitespace-nowrap'>{`${new Date(item.created_at).getDate()}/${new Date(item.created_at).getMonth() + 1}/${new Date(item.created_at).getFullYear()}`}</td>
                        <td className='text-center font-medium text-xl py-2'>{getStatut(item.statut)}</td>
                        <td className='text-center font-medium text-xl py-2'>
                          <div className='flex justify-center items-center'>
                            <Tooltip title="Modifier le statut">
                              <IconButton onClick={() => {
                                setSelectedMessage(item);
                                setOpenStatutDialog(true);
                              }}
                              >
                                <EditIcon sx={{color: 'black'}}/>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Supprimer cette demande">
                              <IconButton onClick={() => {
                                setSelectedMessage(item);
                                setOpenDeleteDialog(true);
                              }}
                              >
                                <DeleteIcon sx={{color: 'black'}}/>
                              </IconButton>
                            </Tooltip>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                }
                {filtredMessages.length === 0 && (
                  <div className='border-dashed border-4 border-primary rounded-[30px] p-5 fixed mx-10 my-8 w-[65vw] md:w-[80vw] lg:w-[85vw]'>
                    <p className='font-inter text-primary font-bold text-xl text-center'>
                      {isLoader ? (<CircularProgress open={isLoader} sx={{color: '#A31732'}}/>) : 'Aucun message'}
                    </p>
                  </div>
                )}
              </tbody>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>
  );
}
